import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const documentProjectRelationDataClassName =
  DataClassName.DOCUMENT_PROJECT_RELATION
const documentProjectRelationEndpoint = PisaDataClassEndpoint.DOCUMENT_PROJECT

export function pisaDocumentProjectRelationDataClass(
  attributes: DataAttributeDefinitions,
) {
  return provideDataClass(documentProjectRelationDataClassName, {
    title: documentProjectRelationDataClassName,
    restApi: createPisaRestApiConfig(documentProjectRelationEndpoint),
    attributes,
  })
}
